import { normalizeCropCode } from "pages/admin/experiments/cropExtraction/cropCodes";
import { findField, findTable, runDbfParser, toNumber, toString } from "pages/admin/experiments/cropExtraction/parsers/genericDbf";
import { ParserResult } from "pages/admin/experiments/cropExtraction/types";

export const parseFiona = (zipBuffer: ArrayBuffer): Promise<ParserResult> =>
  runDbfParser(zipBuffer, {
    notFoundMessage: "FIONA DBF not found or empty",
    pickTable: (tables) => findTable(tables, (b) => b.startsWith("fiona_")) ?? tables[0],
    buildExtractor: (table) => {
      const cropCol = findField(table.rows, ["nutz_code", "NUTZCODE", "ncode_aktu"]);
      const fieldNameCol = findField(table.rows, ["bez", "schlag", "schlagbez", "lage_bez", "name"]);
      const fieldIdCol = findField(table.rows, ["geo_id", "schlagnr", "schlag_id", "fid"]);
      const areaCol = findField(table.rows, ["flaeche_ha", "flaeche", "groesse"]);

      return (row) => {
        const fieldId = fieldIdCol ? toString(row[fieldIdCol]) : "";
        const fieldName = (fieldNameCol && toString(row[fieldNameCol])) || fieldId;
        return {
          fieldId,
          fieldName,
          cropCode: normalizeCropCode(cropCol ? toString(row[cropCol]) : ""),
          cropDescription: "",
          areaHa: areaCol ? toNumber(row[areaCol]) : 0,
          fieldNumber: fieldId || undefined,
        };
      };
    },
  });
